/* MMA – Holzkörper-Ergänzung im Cart Drawer.
   Legt die Variante per Shopify Ajax Cart API in den Warenkorb und
   rendert den Drawer mit Dawns renderContents() neu.
   Klick-Handler hängt am Element selbst; nach einem Re-Render entsteht
   ein neues Element, das alte verschwindet samt Listener. */
if (!customElements.get('mma-cart-extra')) {
  customElements.define(
    'mma-cart-extra',
    class MmaCartExtra extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const button = event.target.closest('.mma-cart-extra__add');
        if (!button || button.disabled) return;
        this.add(button);
      }

      async add(button) {
        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;
        const original = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = '…';
        try {
          const response = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || 'Hinzufügen fehlgeschlagen');

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ id: variantId, sections: state.sections });
          } else {
            window.location.reload();
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mma-cart-extra', productVariantId: variantId });
          }
        } catch (error) {
          console.error('[mma-cart-extra]', error);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = original;
        }
      }
    }
  );
}
